import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-all duration-300 overflow-hidden cursor-pointer"
    >
      <div className="relative overflow-hidden aspect-[5/7]">
        <img
          src={comic.cover}
          alt={`${comic.title} - 51漫画免费下载`}
          title={`51漫画 - ${comic.title}免费下载`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 right-2">
          <span
            className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
              comic.status === '连载中'
                ? 'bg-primary-500 text-background-50'
                : 'bg-secondary-500 text-background-50'
            }`}
          >
            {comic.status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <div className="flex items-center gap-1 text-background-50 text-xs">
            <i className="ri-star-fill text-accent-400 text-xs"></i>
            <span className="font-semibold">{comic.rating}</span>
            <span className="mx-1">·</span>
            <span>{comic.views} 次阅读</span>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{comic.author} · {comic.chapters}话</p>
        <div className="flex flex-wrap gap-1 mt-2">
          {comic.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="inline-block px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded text-xs whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}